'use strict';

(function (HeaderStyle) {
    HeaderStyle["headerWithSearch"] = "headerWithSearch";
    HeaderStyle["headerWithoutSearch"] = "headerWithoutSearch";
    HeaderStyle["noHeader"] = "noHeader";
})(exports.HeaderStyle || (exports.HeaderStyle = {}));
(function (FooterStyle) {
    FooterStyle["footerWithPagination"] = "footerWithPagination";
    FooterStyle["customFooter"] = "customFooter";
    FooterStyle["noFooter"] = "noFooter";
})(exports.FooterStyle || (exports.FooterStyle = {}));
(function (ColumnTypesEnum) {
    ColumnTypesEnum["staticCell"] = "staticCell";
    ColumnTypesEnum["pill"] = "pill";
    ColumnTypesEnum["status"] = "status";
    ColumnTypesEnum["link"] = "link";
    ColumnTypesEnum["linkWithIcon"] = "linkWithIcon";
    ColumnTypesEnum["dropdown"] = "dropdown";
    ColumnTypesEnum["dropdownStatus"] = "dropdownStatus";
    ColumnTypesEnum["button"] = "button";
    ColumnTypesEnum["deleteButton"] = "deleteButton";
    ColumnTypesEnum["date"] = "date";
    ColumnTypesEnum["emailLink"] = "emailLink";
    ColumnTypesEnum["jsxElement"] = "jsxElement";
    ColumnTypesEnum["multiSelect"] = "multiSelect";
})(exports.ColumnTypesEnum || (exports.ColumnTypesEnum = {}));
(function (HeaderTypesEnum) {
    HeaderTypesEnum["filter"] = "filter";
    HeaderTypesEnum["filterSingleSelect"] = "filterSingleSelect";
    HeaderTypesEnum["filterDate"] = "filterDate";
    HeaderTypesEnum["sort"] = "sort";
})(exports.HeaderTypesEnum || (exports.HeaderTypesEnum = {}));
(function (SortDirection) {
    SortDirection["asc"] = "ASC";
    SortDirection["desc"] = "DESC";
})(exports.SortDirection || (exports.SortDirection = {}));

var enums = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get HeaderStyle () { return exports.HeaderStyle; },
  get FooterStyle () { return exports.FooterStyle; },
  get ColumnTypesEnum () { return exports.ColumnTypesEnum; },
  get HeaderTypesEnum () { return exports.HeaderTypesEnum; },
  get SortDirection () { return exports.SortDirection; }
});

exports.enums = enums;
